import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import FetchDataComponent from './FetchDataComponent';

const FetchDataContainer = (props) => {
  const { payload, fetchData, whenToFetch = true, resetData } = props;

  useEffect(() => {
    if (whenToFetch && fetchData) {
      fetchData(payload);
    }

    return () => {
      if (resetData) {
        resetData(payload);
      }
    };
  }, [whenToFetch, payload, fetchData, resetData]);

  return <FetchDataComponent {...props} />;
};

FetchDataContainer.propTypes = {
  payload: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  whenToFetch: PropTypes.bool,
  fetchData: PropTypes.func,
  resetData: PropTypes.func,
};

export default FetchDataContainer;
